import React from "react";
import {CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle} from "@coreui/react";
import {withErrorBoundary} from "../ErrorBoundary";
import {getTranslatedTimeTextFromMinutes} from "../../utils/timeHandlers";
import {useTranslation} from "react-i18next";

const TakeToWorkDropdown = ({
                              className, color, variant, size, placement, incidentId,
                              checkId, pauses, disabled, onTakeToWorkButtonClick, modifiers
                            }) => {
  const {t} = useTranslation();

  return (
    <CDropdown className="dropdown_no-caret">
      <CDropdownToggle
        className={className}
        color={color}
        variant={variant}
        size={size}
        disabled={disabled}
      >
        {t("button.pause", "Take to work")}
      </CDropdownToggle>
      <CDropdownMenu
        placement={placement}
        modifiers={modifiers}
      >
        {pauses.map((pause) => (
          <CDropdownItem
            key={pause[0]}
            onClick={() => onTakeToWorkButtonClick(checkId, pause[0], incidentId)}
          >
            {getTranslatedTimeTextFromMinutes(pause[0])}
          </CDropdownItem>
        ))}
      </CDropdownMenu>
    </CDropdown>
  );
};

TakeToWorkDropdown.defaultProps = {
  className: "btn-block mt-1",
  color: "info",
  variant: "outline",
  size: "sm",
  placement: "left",
};

export default withErrorBoundary(TakeToWorkDropdown);